module.exports = "/_next/static/images/IconSaveMoney-a9463a02b279a1f7707c1ee5cf84ad53.svg";